import { Injectable } from "@angular/core";
import { ILezioneQuiz } from "app/shared/models/lezione_quiz.interface";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceLezioniQuiz extends BASEMysqlService {

  prefix = 'lezioni_quiz_'

  //////////////////////////////////////////////////////////////////////////////////////////

  list(filter?): Promise<any> {
    let data = {
      auth: this.getAuth(),
      filter: filter
    }

   // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
  }

  get(id): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
  }

  upsert(item: ILezioneQuiz): Promise<any[]> {
    let data = {
      auth: this.getAuth(),
      item: item
    }

    return this.http.post<any[]>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
  }

  upsert_result(idZoomPoll: string, risultato): Promise<any[]> {
    let data = {
      auth: this.getAuth(),
      idZoomPoll: idZoomPoll,
      risultato: risultato
    }

    return this.http.post<any[]>(this.URL_BASE + this.prefix + 'update_result', data).toPromise();
  }

  delete(id: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
  }


}